import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'peerlab',
      storage,
      whitelist: ['auth', 'user', 'lab', 'equipment'],
    },
    reducers
  );

  return persistedReducer;
};
